import { fetchBanksEnrolled } from '@api/useQueryCalls';
import { UseQueryResult } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

// Define type for a single bank (customize this with actual structure)
type Bank = {
  id: string;
  name: string;
  [key: string]: any; // or define precise keys if known
};

const useFetchBanks = () => {
  const [bankList, setBankList] = useState<Bank[] | null>(null);

  const { isLoading, refetch, isSuccess, data, isFetching, isFetched, status }: UseQueryResult<any> =
    fetchBanksEnrolled();

  useEffect(() => {
    if (isSuccess && data?.list) {
      setBankList(data.list);
    }
  }, [isSuccess, data]);

  return {
    bankList,
    isSuccess,
    isLoading,
    isFetching,
    isFetched,
    status,
    refetch,
  };
};

export default useFetchBanks;
